import React, { useState, useEffect } from 'react';
import { Card, Form } from '@deere/ux.uxframe-react'
import TableCustom from '../../components/TableCustom';
import RadioGroup from '../../components/RadioGroup';
import CheckGroup from '../../components/CheckGroup';
import { useDispatch, useSelector } from 'react-redux';
import { FLEX_ERR_MSG, FLEXIBILITY_SECTION_NAME, EMPTY_BODY } from '../../utils/surveyLiterals'
import { findAnswerIndex, updateAnswerInArray, removeQuestion, getNewCheckValueAnswer, getTranslation, containsCheckBoxAnswer } from '../../utils/utils';
import { updateSurveyAnswers, removeSurveyAnswer } from '../../redux/action/surveyAction';
import store from '../../redux/store';
import "../../assets/css/Sections.css";
import {DebounceInput} from 'react-debounce-input';
import { useTranslation } from "react-i18next";


function isOtherChecked(question, answers) {
    let isChecked = false;
    let parent = answers.find(qu => parseInt(qu.questionId) === parseInt(question.idQuestionDepends));
    if(parent && containsCheckBoxAnswer(question.idSelectionDependson.toString(),parent.answer)){
        isChecked = true;
    }
    return isChecked;
}


export default function FlexibilityPage({ survey }) {
    const dispatch = useDispatch();
    const [checkSection] = useState(false)
    const surveyResponse = useSelector(state => state.survey.surveyResponse);
    const [answers, setAnswers] = useState([])
    const section = survey.sections.find(e => e.description === FLEXIBILITY_SECTION_NAME && e.active);    
    const questions = section.questions === undefined ? null : section.questions;
    const { t } = useTranslation();
    useEffect(() => {
        setAnswers([...store.getState().survey.surveyAnswers]);
    }, [surveyResponse])

    if (!survey) {
        return EMPTY_BODY;
    }
    if (questions === null) { return <div><p>{FLEX_ERR_MSG}</p></div> }

    const handleCheckChange = (e, idQuestion) => {

        updateCheckAnswer(e, idQuestion);
    } 

    const updateAnswer = (e, questionId) => {
        if( e ) {
            updateAnswerInArray(questionId, answers, e.target ? e.target.value : e);
            dispatch(updateSurveyAnswers({ questionId: questionId, answer: e.target ? e.target.value : e }));
            setAnswers([...store.getState().survey.surveyAnswers])
        }
    }
    const updateCheckAnswer = (e, questionId) => {
        let newCheckValue = getNewCheckValueAnswer(questionId, answers, e);
        if (newCheckValue === null || newCheckValue === '' || newCheckValue === ',') {//Remove Question
            removeQuestion(questionId, answers);
            dispatch(removeSurveyAnswer(questionId));
        } else {//Update Question
            updateAnswerInArray(questionId, answers, newCheckValue);
            dispatch(updateSurveyAnswers({ questionId: questionId, answer: newCheckValue }));
        }
        setAnswers([...store.getState().survey.surveyAnswers])
    }

    const createOption = ( question ) => {
        return  <Form.Row className="d-block mb-4">
                    <Form.Group>
                        <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                        <RadioGroup radioLabels={question ? question.selections : []}
                            updateAnswer={updateAnswer} question={question}
                            defaultValue={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ''} 
                            section={getTranslation(section, 'description')}
                            checkedProprietary={checkSection}/>
                    </Form.Group>
                </Form.Row>
    }

    const createCheck = ( question, ind ) => {
        return <Form.Row className="d-block mb-4">
            <Form.Group>
                <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                <div><CheckGroup key={ind} checkSelections={question ? question.selections : []}
                    handleChange={handleCheckChange} question={question}
                    currentChecked={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ''} 
                    section={getTranslation(section, 'description')}
                    checkedproprietary={checkSection}/></div>
            </Form.Group>
        </Form.Row>
    }

    const createTextArea = ( question ) => {
        return <Form.Row className="d-block mb-4">
        {isOtherChecked(question,answers) && <Form.Group className="mb-4 pl-4">
               <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
               <DebounceInput element="textarea" debounceTimeout={300}
                   required={!checkSection} className="form-control"                            
                   onChange={e => updateAnswer(e, question.id)}                             
                   value={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ''}
                   name={`${getTranslation(section, 'description')}-${question.id}`}/>    
               <div className="invalid-feedback">
                   {t('bs_required')}
               </div>
           </Form.Group>}
       </Form.Row>
    }

    if (survey === null) { return <></> }
    return (<>
        <Card>
            <Card.Body id={section ? section.description : ''}>
                <Card.Title className='pb-3 font-weight-bold'>
                    {getTranslation(section,'description')}
                </Card.Title>
                {
                    questions.map((question, ind) => {
                        if( question.type === 'OPTION') {
                            return createOption( question );
                        }

                        if( question.type === 'CHECK' ) {
                            return createCheck( question, ind );
                        }

                        if( question.type === 'OPEN' ) {
                            return createTextArea( question );
                        }

                        return <></>;
                    })
                }
                
                <Form.Row className="d-block mb-4">
                    <Form.Group>
                        <TableCustom 
                            questions={questions} 
                            answers={answers} 
                            updateAnswer={updateAnswer} 
                            section={getTranslation(section, 'description')} 
                            checkedproprietary={checkSection.toString()}
                        />
                    </Form.Group>
                </Form.Row>

            </Card.Body>
        </Card>
    </>)

}
